import React from 'react';
import { ChevronRight, Briefcase, Users } from 'lucide-react';

const BRAND_COLORS = {
  primary: '#1a1a1a',
  secondary: '#7C3AED',
  accent: '#C9A961',
  light: '#F5F5F0',
  lightGray: '#E8E8E3',
};

const RoleSelection = ({ onSelectRole }) => {
  return (
    <div className="bg-white border-2 p-10" style={{ borderColor: BRAND_COLORS.primary }}>
      <div className="mb-10">
        <p className="text-xs font-light tracking-widest mb-4" style={{ color: BRAND_COLORS.accent }}>
          GET STARTED
        </p>
        <h3 className="text-3xl font-light tracking-wide mb-4" style={{ color: BRAND_COLORS.primary }}>
          Join as a Professional or Employer
        </h3>
        <p className="text-gray-600 font-light leading-relaxed">
          Choose how you want to use SkillVend
        </p>
      </div>

      <div className="space-y-4">
        {/* Professional Option */}
        <button
          onClick={() => onSelectRole('professional')}
          className="w-full p-6 border-2 bg-transparent font-light transition-all duration-300 hover:border-black hover:bg-gray-50 group text-left"
          style={{ borderColor: BRAND_COLORS.lightGray }}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 border-2 flex items-center justify-center transition-all duration-300 group-hover:border-black" style={{ borderColor: BRAND_COLORS.secondary }}>
                <Users className="w-6 h-6" style={{ color: BRAND_COLORS.secondary }} />
              </div>
              <div>
                <h4 className="text-lg font-light mb-2 tracking-wide" style={{ color: BRAND_COLORS.primary }}>
                  I'm a Professional
                </h4>
                <p className="text-sm font-light text-gray-600 leading-relaxed">
                  Looking for flexible work opportunities and want to earn on my own schedule
                </p>
              </div>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400 transition-transform duration-300 group-hover:translate-x-2 flex-shrink-0" />
          </div>
        </button>

        {/* Employer Option */}
        <button
          onClick={() => onSelectRole('employer')}
          className="w-full p-6 border-2 bg-transparent font-light transition-all duration-300 hover:border-black hover:bg-gray-50 group text-left"
          style={{ borderColor: BRAND_COLORS.lightGray }}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 border-2 flex items-center justify-center transition-all duration-300 group-hover:border-black" style={{ borderColor: BRAND_COLORS.accent }}>
                <Briefcase className="w-6 h-6" style={{ color: BRAND_COLORS.accent }} />
              </div>
              <div>
                <h4 className="text-lg font-light mb-2 tracking-wide" style={{ color: BRAND_COLORS.primary }}>
                  I'm an Employer
                </h4>
                <p className="text-sm font-light text-gray-600 leading-relaxed">
                  Looking to hire skilled professionals for my business needs
                </p>
              </div>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400 transition-transform duration-300 group-hover:translate-x-2 flex-shrink-0" />
          </div>
        </button>
      </div>
    </div>
  );
};

export default RoleSelection;
